import { FaDollarSign, FaBolt, FaLock } from 'react-icons/fa'
import { colors } from '../../../utilities/colors'

export const priceOptionColors = {
  economy: colors.green,
  expedited: colors.yellow,
  enclosed: '#4A90D9',
}

export const priceOptionIcons = {
  economy: FaDollarSign,
  expedited: FaBolt,
  enclosed: FaLock,
}
